"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _pclnDesignSystem = require("pcln-design-system");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var zoomIn = (0, _styledComponents.keyframes)(["from{transform:scale(0);}to{transform:scale(1);}"]);
var bounceOver = (0, _styledComponents.keyframes)(["0%{transform:rotate(0deg) translate(0em,0em);}75%{transform:rotate(90deg) translate(0em,-2em);}100%{transform:rotate(90deg) translate(0em,-2em);}"]);
var moveOver = (0, _styledComponents.keyframes)(["from{transform:translate(2em,0em);}to{transform:translate(4em,0em);}"]);

var Container = _styledComponents["default"].div.withConfig({
  componentId: "txbwo-0"
})(["position:relative;width:5em;height:1.75em;font-size:", "px;> div{background-color:", ";border-radius:50%;height:1em;width:1em;position:absolute;bottom:0;animation:", " 0.56s linear infinite;&:nth-child(2){animation-name:", ";}&:nth-child(3){animation-name:", ";animation-timing-function:ease-in;}&:last-child{animation-direction:reverse;right:0;}}"], function (props) {
  return props.size * 16;
}, (0, _pclnDesignSystem.getPaletteColor)('base'), zoomIn, bounceOver, moveOver);

function Spinner(props) {
  return _react["default"].createElement(Container, props, _react["default"].createElement("div", null), _react["default"].createElement("div", null), _react["default"].createElement("div", null), _react["default"].createElement("div", null));
}

Spinner.propTypes = _objectSpread({
  size: _propTypes["default"].number
}, _styledSystem.color.PropTypes);
Spinner.defaultProps = {
  size: 1,
  color: 'primary'
};

var _default = (0, _styledComponents.withTheme)(Spinner);

exports["default"] = _default;